<template>
  <div class="report-post">
    <div class="report-post-button" @click="openModal">
      <a class="report-post-text">
        {{ $t('post.postReport.reportText') }}
      </a>
    </div>
    <modal-confirm
      class="confirm-report"
      @click.stop
      @confirm="reportPost()"
      @close="closeModal()"
      :cancel="$t('post.postReport.back')"
      :confirm="$t('post.postReport.report')"
      :title="$t('post.postReport.reportAPost')"
      :message="$t('post.postReport.reportConfirmation')"
      :show-modal="showModal"
    />
  </div>
</template>

<script>
import ModalConfirm from '@/components/shared/ModalConfirm'

export default {
  name: 'PostReport',
  components: { ModalConfirm },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    closeModal() {
      this.showModal = false
    },
    openModal() {
      this.showModal = true
    },
    reportPost() {
      this.$store.dispatch('report', this.post.id)
      this.showModal = false
      this.$toasted.global.success(this.$t('post.postReport.sentToCAnnect'))
    }
  }
}
</script>

<style scoped lang="scss">
  .report-post {
    width: 100%;
    height: 100%;
  }

  .report-post-button {
    padding: 4px 12px;
    width: 100%;
    height: 100%;
  }
</style>
